  let currentReminderCount = 0;
  let currentReminderId = 0;
  let currentBlock = null;
function showReminderSection(sectionName) {
    if(currentReminderCount >= 5 && sectionName === "form") {
      sectionName = "last";
    }
    const sections = {
      form: document.querySelector(".reminder-form"),
      view: document.querySelector(".reminder-view"),
      discount: document.querySelector(".reminder-discount"),
      last: document.querySelector(".reminder-last")
    };

    Object.entries(sections).forEach(([key, element]) => {
      if (element) {
        element.style.display = key === sectionName ? "block" : "none";
      }
    });
  }
  function createReminderBlock(reminder) {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const fullLabel = reminder.eventType === "others"
    ? `${reminder.sendTo} - ${reminder.occasion}`
    : `${reminder.sendTo} - ${reminder.eventType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}`;
  const dateLabel = `${reminder.day} ${monthNames[reminder.month - 1]}`;
  const block = document.createElement("div");
  block.className = "reminder-block";
  block.innerHTML = `
    <div class="reminder-block-content">
      <h6 class="h8">${fullLabel}</h6>
      <p class="p-small">Date: <b>${dateLabel}</b></p>
    </div>
    <div class="rem-del-svg" data-id="${reminder.id}" title="Delete Reminder">
      ${document.getElementById("reminder-delete-template")?.innerHTML || ""}
    </div>
  `;
  return block;
}

document.addEventListener("DOMContentLoaded", function () {
  const ServerUrl = "https://fs-reminder-backend-production.up.railway.app";
  // const ServerUrl = "http://localhost:3000";
  const reminderForm = document.getElementById("event-reminder-form");
  const openBtn = document.getElementById("openReminderPopup");
  const openRemBtn = document.getElementById("openRemPopup");
  const overlay = document.querySelector(".reminder-overlay");
  const closeBtn = document.querySelector(".reminder_close-popup");
  const eventTypeSelect = document.querySelector('select[name="eventType"]');
  const occasionWrapper = document.querySelector(".reminder-occasion");
  const occasionInput = occasionWrapper?.querySelector('input[name="occasion"]');
  const nameInput = document.querySelector('input[name="name"]');
  const emailInput = document.querySelector('input[name="email"]');
  const monthSelect = document.getElementById("reminder-month");
  const daySelect = document.getElementById("reminder-day");
  const reminderName = nameInput?.value.trim() || '';
  const reminderEmail = emailInput?.value.trim() || '';
  const reminderCount = document.querySelector(".reminder-currentCount");
  const reminderAway = document.querySelector(".reminder-away");
  const reminderLoader = document.querySelector(".reminder-loader");
  const reminderBlocks = document.querySelector(".reminder-blocks");
  const reminderViewBtn = document.querySelector(".reminder-view-btn");
  const discountCode = document.querySelectorAll(".discountCode");
  const daysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const delPopup = document.getElementById('delPopup');
  const delPopupOverlay = document.getElementById('delPopupOverlay');
  const closeDelPopup = document.querySelector('.closeDelPopup');
  const removeReminder = document.querySelector('.removeReminder');
  function populateMonths() {
    daysInMonth.forEach((_, i) => {
      const option = new Option(
        new Date(0, i).toLocaleString("default", { month: "long" }),
        i + 1
      );
      monthSelect.appendChild(option);
    });
  }
  function populateDays(monthIndex) {
    const totalDays = daysInMonth[monthIndex];
    daySelect.innerHTML = '<option value="">Select</option>';
    for (let i = 1; i <= totalDays; i++) {
      daySelect.innerHTML += `<option>${i}</option>`;
    }
  }
  function toggleOccasionField() {
    const isOther = eventTypeSelect?.value === "others";
    occasionWrapper.style.display = isOther ? "block" : "none";
    if (occasionInput) occasionInput.required = isOther;
  }
  function openOverlay() {
    overlay.style.display = "flex";
    fetchReminders();
  }
  function closeOverlay() {
    overlay.style.display = "none";
  }
  function updateAddAnotherBtns(count) {
  document.querySelectorAll(".js-add-reminder-btn").forEach(btn => {
    const isFull = count >= 5;
    btn.textContent = isFull ? "View Summary" : "Add Another Reminder";
    btn.onclick = (e) => { e.preventDefault(); showReminderSection(isFull ? "last" : "form"); };
  });
  }
  async function fetchReminders(submit=false) {
    try {
      reminderLoader.style.display = "flex";
      const response = await fetch(`${ServerUrl}/api/reminders?userEmail=${encodeURIComponent(reminderEmail)}`);
      reminderLoader.style.display = "none";
      if (!response.ok) throw new Error("Failed to fetch reminders");
      const data = await response.json();
      currentReminderCount = data.reminders.length || 1;
      updateAddAnotherBtns(currentReminderCount);
      if (data.reminders.length === 5) {
        discountCode.forEach(code => {
          code.textContent = data.user.discountCode;
        })
        showReminderSection(submit ? "view" : "last");
      } 
      else if (data.reminders.length === 3) {
        reminderAway.parentElement.style.display = "none";
        discountCode.forEach(code => {
          code.textContent = data.user.discountCode;
        }
        );
        showReminderSection("discount");
      } else {
        reminderAway.parentElement.style.display = "block";
        showReminderSection(submit ? "view" : "form");
        if(data.reminders.length < 1) {
          reminderViewBtn.style.display = "none";
        } else {
          reminderViewBtn.style.display = "block";
        }
      }
      reminderCount.textContent = data.reminders.length ? data.reminders.length : 1;
      reminderAway.textContent = data.reminders.length ? 3 - data.reminders.length : 3;
      reminderBlocks.innerHTML = "";
      data.reminders.forEach(reminder => {
        const reminderElement = createReminderBlock(reminder);
        reminderBlocks.appendChild(reminderElement);
      });
    } catch (error) {
      console.error("Error fetching reminders:", error);
    }
  }
  async function submitForm(e) {
    e.preventDefault();
    const formData = new FormData(reminderForm);
    const eventDate = formData.get("eventDate");
    let month = formData.get("month");
    let day = formData.get("day");
    if (eventDate) {
      const date = new Date(eventDate);
      month = date.getMonth() + 1;
      day = date.getDate();
    }
    const payload = {
      userEmail: reminderEmail,
      userName: reminderName,
      sendTo: formData.get("sendTo"),
      eventType: formData.get("eventType"),
      occasion: formData.get("occasion") || '',
      month,
      day
    };
    try {
      reminderLoader.style.display = "flex";
      const res = await fetch(`${ServerUrl}/api/reminders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      if (res.ok) {
        reminderForm.reset();
        await fetchReminders(true);
        reminderLoader.style.display = "none";
      } else {
        reminderLoader.style.display = "none";
        console.error("Failed to add reminder:", result.error);
      }
    } catch (err) {
      console.error("Error submitting reminder:", err);
    }
  }
  async function deleteReminder(reminderId) {
  try {
    const response = await fetch(`${ServerUrl}/api/reminders/${reminderId}?userEmail=${encodeURIComponent(reminderEmail)}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`Failed to delete reminder: ${response.statusText}`);
    }
    const data = await response.json();
    console.log('Reminder deleted successfully:', data);
    return data;
  } catch (error) {
    console.error('Error deleting reminder:', error);
    throw error;
  }
}
const handleDelete = async (reminderId, deleteBlock) => {
    reminderLoader.style.display = "flex";
    const success = await deleteReminder(reminderId);
    reminderLoader.style.display = "none";
    delPopup.style.display = 'none';
    delPopupOverlay.style.display = 'none';
  if (success) {
    deleteBlock?.remove();
    fetchReminders();
  }
  }
  closeDelPopup.addEventListener('click', () => {
      delPopup.style.display = 'none';
      delPopupOverlay.style.display = 'none';
    });
  removeReminder.addEventListener('click', async () => {
    handleDelete(currentReminderId, currentBlock);
  })
  // Initial Setup
  populateMonths();
  monthSelect.onchange = e => populateDays(+e.target.value - 1);
  eventTypeSelect?.addEventListener("change", toggleOccasionField);
  toggleOccasionField();
  openBtn?.addEventListener("click", () => {
    if (!reminderEmail) {
      localStorage.setItem("reminder_popup_requested", "true");
      const loginUrl = window.Shopify?.customerAccountAPI?.redirectToLogin
        ? null
        : "https://fd0ec5-d2.myshopify.com/customer_authentication/login?return_to=%2F";
      if (loginUrl) {
        window.location.href = loginUrl;
      } else {
        window.Shopify.customerAccountAPI.redirectToLogin({
          returnTo: window.location.href,
        });
      }
      return;
    }
    openOverlay();
  });

  //Open Popup Button for Reminder Card
  openRemBtn?.addEventListener("click", () => {
    console.log("Reminder Button Clicked");
    if (!reminderEmail) {
      localStorage.setItem("reminder_popup_requested", "true");
      const loginUrl = window.Shopify?.customerAccountAPI?.redirectToLogin
        ? null
        : "https://fd0ec5-d2.myshopify.com/customer_authentication/login?return_to=%2F";
      if (loginUrl) {
        window.location.href = loginUrl;
      } else {
        window.Shopify.customerAccountAPI.redirectToLogin({
          returnTo: window.location.href,
        });
      }
      return;
    }
    openOverlay();
  });
  //End
  
  closeBtn?.addEventListener("click", closeOverlay);
  overlay?.addEventListener("click", (e) => {
    if (e.target === overlay) closeOverlay();
  });
  reminderForm?.addEventListener("submit", submitForm);
  if (reminderEmail && localStorage.getItem("reminder_popup_requested") === "true") {
    localStorage.removeItem("reminder_popup_requested");
    setTimeout(openOverlay, 200);
  }
  reminderBlocks.addEventListener("click", async (e) => {
  const deleteBtn = e.target.closest(".rem-del-svg");
  if (!deleteBtn) return;
  const reminderId = deleteBtn.getAttribute("data-id");
  if (!reminderId) return;
  delPopup.style.display = "block";
  delPopupOverlay.style.display = "block";
  currentReminderId = reminderId;
  currentBlock = deleteBtn.closest(".reminder-block");
});
const checkHashAndOpen = () => {
    if (window.location.hash === "#openRemPopup") {
      if (!reminderEmail) {
        localStorage.setItem("reminder_popup_requested", "true");
        const loginUrl = window.Shopify?.customerAccountAPI?.redirectToLogin
          ? null
          : "https://fd0ec5-d2.myshopify.com/customer_authentication/login?return_to=%2F";
        if (loginUrl) {
          window.location.href = loginUrl;
        } else {
          window.Shopify.customerAccountAPI.redirectToLogin({
            returnTo: window.location.href,
          });
        }
      } else {
        openOverlay();
      }
    }
  };
  checkHashAndOpen();
  window.addEventListener("hashchange", checkHashAndOpen);
  console.log("Reminder script loaded atem1");
});
// Discount Code Copy 
 function handleCopyClick(element) {
    const container = element.closest('.reminder-dis-block');
    const codeElement = container.querySelector('.discountCode');
    const code = codeElement.textContent.trim();
    navigator.clipboard.writeText(code).then(() => {
      const svgDone = element.querySelector('.done');
      const svgNotDone = element.querySelector('.notDone');
      svgDone.style.display = 'inline';
      svgNotDone.style.display = 'none';
      setTimeout(() => {
        svgDone.style.display = 'none';
        svgNotDone.style.display = 'inline';
      }, 2000);
    });
  }